import { render, staticRenderFns } from "./despatch-order.vue?vue&type=template&id=7a5c4c3b"
import script from "./despatch-order.vue?vue&type=script&lang=js"
export * from "./despatch-order.vue?vue&type=script&lang=js"
import style0 from "./despatch-order.vue?vue&type=style&index=0&id=7a5c4c3b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports